import axios from '../../app/api/axios';
import {GET_ERRORS} from '../Errors/types';
import {
    GET_COURSE,
    COURSE_LOADING,
    GET_COURSES,
    COURSES_LOADING,
    GET_COURSES_CATEGORIES,
    GET_COURSES_LEVELS,
    GET_COURSES_TYPES,
    TAXONOMIES_LOADING,
    SET_COURSES_SEARCH_CRITERIA,
    RESET_COURSES_SEARCH_CRITERIA,
    GET_OTHER_COURSES_CATEGORY,
    OTHER_COURSES_CATEGORY_LOADING,
    SIGNUP_TO_COURSE,
    SIGNOUT_FROM_COURSE,
    SIGNUPOROUT_TO_COURSE_LOADING,
    SIGNUPOROUT_TO_COURSE_FAILURE,
    DASHBOARD_GET_COURSES_CHECKEDIN,
    DASHBOARD_GET_COURSES_AUTHOR,
    DASHBOARD_GET_COURSES_LOADING,
} from "./types"

export const getCourses = (page = 1, newSearch = false, category = '', level = '', type = '', english = false, suggestions = false) => dispatch => {
    dispatch(setCoursesLoading());

    const minLoadingTime = 0;
    let startTime = new Date().getTime();

    axios
        .post('ifp/v1/courses', {
            page: page,
            category: category,
            level: level,
            type: type,
            english: english,
            suggestions: suggestions,
        })
        .then(function(res) {
            let fakeLoadingTime = 0;
            let requestTime = new Date().getTime() - startTime;

            if (requestTime < minLoadingTime) {
                fakeLoadingTime = minLoadingTime - requestTime;
            }

            setTimeout(() => {
                dispatch({
                    type: GET_COURSES,
                    payload: res.data,
                    page: page,
                    newSearch: newSearch,
                    fakeLoadingTime: fakeLoadingTime,
                    search: {
                        category: category,
                        level: level,
                        type: type,
                        english: english,
                        suggestions: suggestions,
                    }
                });
            }, fakeLoadingTime);
        })
        .catch(err =>
            dispatch({
                type: GET_COURSES,
                payload: null
            })
        );
};

export const getCourse = (slug) => dispatch => {
    dispatch(setCourseLoading());

    axios
        .get('ifp/v1/course/' + slug)
        .then(res =>
            dispatch({
                type: GET_COURSE,
                payload: res.data
            })
        )
        .catch(function (err) {
            dispatch({
                type: GET_COURSE,
                payload: null
            });
            dispatch({
                type: GET_ERRORS,
                payload: {
                    status: err.response.status
                }
            });
        });
};

export const getCoursesCategories = () => dispatch => {
    dispatch(setTaxonomiesLoading());

    axios
        .get('ifp/v1/courses/taxonomy/category')
        .then(res =>
            dispatch({
                type: GET_COURSES_CATEGORIES,
                payload: res.data
            })
        )
        .catch(err =>
            dispatch({
                type: GET_COURSES_CATEGORIES,
                payload: null
            })
        );
};

export const getCoursesLevels = () => dispatch => {
    dispatch(setTaxonomiesLoading());

    axios
        .get('ifp/v1/courses/taxonomy/level')
        .then(res =>
            dispatch({
                type: GET_COURSES_LEVELS,
                payload: res.data
            })
        )
        .catch(err =>
            dispatch({
                type: GET_COURSES_LEVELS,
                payload: null
            })
        );
};

export const getCoursesTypes = () => dispatch => {
    dispatch(setTaxonomiesLoading());

    axios
        .get('ifp/v1/courses/taxonomy/type')
        .then(res =>
            dispatch({
                type: GET_COURSES_TYPES,
                payload: res.data
            })
        )
        .catch(err =>
            dispatch({
                type: GET_COURSES_TYPES,
                payload: null
            })
        );
};

export const getOtherCoursesCategory = (idCategory, idCourse) => dispatch => {
    dispatch(setOtherCoursesCategoryLoading());

    axios
        .post('ifp/v1/courses_from_category', {
            category: idCategory,
            excluded: idCourse,
        })
        .then(res =>
            dispatch({
                type: GET_OTHER_COURSES_CATEGORY,
                payload: res.data
            })
        )
        .catch(err =>
            dispatch({
                type: GET_OTHER_COURSES_CATEGORY,
                payload: null
            })
        );
};

export const setCoursesSearchCriteria = (category = '', level = '', type = '', english = false, suggestions = false) => dispatch => {
    dispatch({
        type: SET_COURSES_SEARCH_CRITERIA,
        searchTaxonomyCategory: category,
        searchTaxonomyLevel: level,
        searchTaxonomyType: type,
        searchEnglish: english,
        searchSuggestions: suggestions,
    })
};

export const resetCoursesSearchCriteria = (category = '', level = '', type = '', english = false, suggestions = false) => dispatch => {
    dispatch({
        type: RESET_COURSES_SEARCH_CRITERIA,
        searchTaxonomyCategory: category,
        searchTaxonomyLevel: level,
        searchTaxonomyType: type,
        searchEnglish: english,
        searchSuggestions: suggestions,
    })
};

export const signupToCourse = (slug) => dispatch => {
    dispatch(setSignupoutLoading());

    axios
        .post('ifp/v1/course/' + slug + '/signup')
        .then(res =>
            dispatch({
                type: SIGNUP_TO_COURSE,
                payload: res.data
            })
        )
        .catch(err =>
            dispatch({
                type: SIGNUPOROUT_TO_COURSE_FAILURE,
                payload: err.response.data
            })
        );
};

export const signoutToCourse = (slug) => dispatch => {
    dispatch(setSignupoutLoading());

    axios
        .delete('ifp/v1/course/' + slug + '/signup')
        .then(res =>
            dispatch({
                type: SIGNOUT_FROM_COURSE,
                payload: res.data
            })
        )
        .catch(err =>
            dispatch({
                type: SIGNUPOROUT_TO_COURSE_FAILURE,
                payload: err.response.data
            })
        );
};

export const dashboardGetCoursesCheckedin = (page = 1, newSearch = false) => dispatch => {
    dispatch(setDashboardCoursesLoading());

    const minLoadingTime = 0;
    let startTime = new Date().getTime();

    axios
        .post('ifp/v1/courses_user_checkedin', {
            page: page
        })
        .then(function(res) {
            let fakeLoadingTime = 0;
            let requestTime = new Date().getTime() - startTime;

            if (requestTime < minLoadingTime) {
                fakeLoadingTime = minLoadingTime - requestTime;
            }

            setTimeout(() => {
                dispatch({
                    type: DASHBOARD_GET_COURSES_CHECKEDIN,
                    payload: res.data,
                    page: page,
                    newSearch: newSearch,
                    fakeLoadingTime: fakeLoadingTime
                });
            }, fakeLoadingTime);
        })
        .catch(err =>
            dispatch({
                type: DASHBOARD_GET_COURSES_CHECKEDIN,
                payload: null
            })
        );
};

export const dashboardGetCoursesAuthor = (page = 1, newSearch = false) => dispatch => {
    dispatch(setDashboardCoursesLoading());

    const minLoadingTime = 0;
    let startTime = new Date().getTime();

    axios
        .post('ifp/v1/courses_user_author', {
            page: page
        })
        .then(function(res) {
            let fakeLoadingTime = 0;
            let requestTime = new Date().getTime() - startTime;

            if (requestTime < minLoadingTime) {
                fakeLoadingTime = minLoadingTime - requestTime;
            }

            setTimeout(() => {
                dispatch({
                    type: DASHBOARD_GET_COURSES_AUTHOR,
                    payload: res.data,
                    page: page,
                    newSearch: newSearch,
                    fakeLoadingTime: fakeLoadingTime
                });
            }, fakeLoadingTime);
        })
        .catch(err =>
            dispatch({
                type: DASHBOARD_GET_COURSES_AUTHOR,
                payload: null
            })
        );
};

export const setCourseLoading = () => {
    return {
        type: COURSE_LOADING
    };
};

export const setCoursesLoading = () => {
    return {
        type: COURSES_LOADING
    };
};

export const setDashboardCoursesLoading = () => {
    return {
        type: DASHBOARD_GET_COURSES_LOADING
    };
};

export const setTaxonomiesLoading = () => {
    return {
        type: TAXONOMIES_LOADING
    };
};

export const setOtherCoursesCategoryLoading = () => {
    return {
        type: OTHER_COURSES_CATEGORY_LOADING
    };
};

export const setSignupoutLoading = () => {
    return {
        type: SIGNUPOROUT_TO_COURSE_LOADING
    };
};



// WEBPACK FOOTER //
// ./src/features/Courses/actions.js